import cn from "classnames";
import { TitleProps } from "./types";
import styles from "./styles.module.scss";

export const DialogTitle = ({ children, className }: TitleProps) => (
  <h2 className={cn(styles.title, className)}>{children}</h2>
);
